/**
 * @license lucide-react v0.570.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createLucideIcon from '../createLucideIcon.js';

const __iconNode = [
  ["path", { d: "M14 2v5a1 1 0 0 0 1 1h5", key: "wfsgrz" }],
  ["path", { d: "M4 12v6", key: "bg1pfk" }],
  ["path", { d: "M4 14h2", key: "1sf9f8" }],
  [
    "path",
    {
      d: "M9.65 22H18a2 2 0 0 0 2-2V8a2.4 2.4 0 0 0-.706-1.706l-3.588-3.588A2.4 2.4 0 0 0 14 2H6a2 2 0 0 0-2 2v4",
      key: "d56i0q"
    }
  ],
  ["circle", { cx: "4", cy: "20", r: "2", key: "6kqj1y" }]
];
const FileKey = createLucideIcon("file-key", __iconNode);

export { __iconNode, FileKey as default };
//# sourceMappingURL=file-key.js.map
